import React from "react";
import { hourlyCalc, money } from "../lib/hourly";

const Row = ({ label, sub, children, soft }) => (
  <div className="liab-row" style={soft ? { background: "var(--primary-soft)" } : undefined}>
    <div>
      <div>{label}</div>
      {sub ? <div className="liab-sub">{sub}</div> : null}
    </div>
    <div className="liab-val" style={soft ? { fontSize: 17 } : undefined}>
      {children}
    </div>
  </div>
);

/**
 * The price of an hourly job worked out from its contract terms — the
 * prototype's hourlyPricingHTML, without the minimum, admin fee and deposit
 * rows (dropped per Miles, 2026-10-15).
 */
export const HourlyPricing = ({ job }) => {
  const c = hourlyCalc(job);
  if (!c) return null;
  const hasHours = c.booked > 0;
  return (
    <div className="liab-card">
      <Row label="Movers included" sub="Truck included">
        {c.movers} movers
      </Row>
      <Row label="Hourly rate">{money(c.rate)}/hr</Row>
      <Row label="Hours booked" sub={hasHours ? "From the contract" : "No hours on the contract yet"}>
        {hasHours ? `${c.booked} hours` : "—"}
      </Row>
      <Row soft label="Estimated price" sub={hasHours ? `${c.estHours} hrs × ${money(c.rate)}` : ""}>
        {hasHours ? money(c.est) : "—"}
      </Row>
    </div>
  );
};

const signed = (n) => (n > 0 ? "+" : n < 0 ? "−" : "") + money(Math.abs(n));

/**
 * Post Move, hourly jobs: the first contract's estimate next to the updated
 * contract's total after the service, and the difference, so the MC sees what
 * changed (Miles, 2026-10-17). The final total is the BOL's own total when it
 * carries one, else hours worked × rate; until the BOL is in it says so.
 */
export const HourlyFinal = ({ job }) => {
  const c = hourlyCalc(job);
  if (!c) return null;
  const hasEst = c.booked > 0;
  return (
    <div className="liab-card hourly-final">
      <Row label="First contract (estimate)" sub={hasEst ? `${c.estHours} hrs × ${money(c.rate)}` : "No hours on the contract"}>
        {hasEst ? money(c.est) : "—"}
      </Row>
      <Row label="Updated contract (after the service)" sub={c.hasFinal ? `${c.finalHours} hrs worked` : "BOL not in yet"}>
        {c.hasFinal ? money(c.final) : "—"}
      </Row>
      <Row soft label="Difference" sub={c.hasFinal && hasEst ? (c.diff > 0 ? "More than estimated" : c.diff < 0 ? "Less than estimated" : "As estimated") : ""}>
        {c.hasFinal && hasEst ? signed(c.diff) : "—"}
      </Row>
    </div>
  );
};
